import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// English namespaces
import enCommon from "../locales/en/common.json";
import enNavigation from "../locales/en/navigation.json";
import enLanding from "../locales/en/landing.json";
import enAuth from "../locales/en/auth.json";
import enShipments from "../locales/en/shipments.json";
import enShipmentGroup from "../locales/en/shipmentgroup.json";
import enUsers from "../locales/en/users.json";
import enPartners from "../locales/en/partners.json";
import enAddresses from "../locales/en/addresses.json";
import enVehicles from "../locales/en/vehicles.json";
import enServices from "../locales/en/services.json";
import enCostServices from "../locales/en/costservices.json";
import enCalendar from "../locales/en/calendar.json";
import enDashboard from "../locales/en/dashboard.json";
import enHelp from "../locales/en/help.json";
import enValidation from "../locales/en/validation.json";
import enNotifications from "../locales/en/notifications.json";
import enSuperadmin from "../locales/en/superadmin.json";
import enEntityModal from "../locales/en/entitymodal.json";
import enPWA from "../locales/en/pwa.json";
import enTasks from "../locales/en/tasks.json";
import enWorks from "../locales/en/works.json";

// Estonian namespaces
import etCommon from "../locales/et/common.json";
import etNavigation from "../locales/et/navigation.json";
import etLanding from "../locales/et/landing.json";
import etAuth from "../locales/et/auth.json";
import etShipments from "../locales/et/shipments.json";
import etShipmentGroup from "../locales/et/shipmentgroup.json";
import etUsers from "../locales/et/users.json";
import etPartners from "../locales/et/partners.json";
import etAddresses from "../locales/et/addresses.json";
import etVehicles from "../locales/et/vehicles.json";
import etServices from "../locales/et/services.json";
import etCostServices from "../locales/et/costservices.json";
import etCalendar from "../locales/et/calendar.json";
import etDashboard from "../locales/et/dashboard.json";
import etHelp from "../locales/et/help.json";
import etValidation from "../locales/et/validation.json";
import etNotifications from "../locales/et/notifications.json";
import etSuperadmin from "../locales/et/superadmin.json";
import etEntityModal from "../locales/et/entitymodal.json";
import etPWA from "../locales/et/pwa.json";
import etTasks from "../locales/et/tasks.json";
import etWorks from "../locales/et/works.json";

import enInvoicing from "../locales/en/invoicing.json";
import etInvoicing from "../locales/et/invoicing.json";

import enOrders from "../locales/en/orders.json";
import etOrders from "../locales/et/orders.json";
import enContainerOrders from "../locales/en/containerOrders.json";
import etContainerOrders from "../locales/et/containerOrders.json";
import enContainerOrderIntake from "../locales/en/containerOrderIntake.json";
import etContainerOrderIntake from "../locales/et/containerOrderIntake.json";
import enDevices from "../locales/en/devices.json";
import etDevices from "../locales/et/devices.json";

export const defaultNS = "common";

export const ns = [
  "common",
  "navigation",
  "landing",
  "auth",
  "shipments",
  "users",
  "partners",
  "addresses",
  "vehicles",
  "services",
  "costservices",
  "calendar",
  "dashboard",
  "help",
  "validation",
  "notifications",
  "superadmin",
  "shipmentGroup",
  "entityModal",
  "pwa",
  "tasks",
  "works",
  "invoicing",
  "orders",
  "containerOrders",
  "containerOrderIntake",
  "devices",
] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        navigation: enNavigation,
        landing: enLanding,
        auth: enAuth,
        shipments: enShipments,
        users: enUsers,
        partners: enPartners,
        addresses: enAddresses,
        vehicles: enVehicles,
        services: enServices,
        costservices: enCostServices,
        calendar: enCalendar,
        dashboard: enDashboard,
        help: enHelp,
        validation: enValidation,
        notifications: enNotifications,
        superadmin: enSuperadmin,
        shipmentGroup: enShipmentGroup,
        pwa: enPWA,
        entityModal: enEntityModal,
        tasks: enTasks,
        works: enWorks,
        invoicing: enInvoicing,
        orders: enOrders,
        containerOrders: enContainerOrders,
        containerOrderIntake: enContainerOrderIntake,
        devices: enDevices,
      },
      et: {
        common: etCommon,
        navigation: etNavigation,
        landing: etLanding,
        auth: etAuth,
        shipments: etShipments,
        users: etUsers,
        partners: etPartners,
        addresses: etAddresses,
        vehicles: etVehicles,
        services: etServices,
        costservices: etCostServices,
        calendar: etCalendar,
        dashboard: etDashboard,
        help: etHelp,
        validation: etValidation,
        notifications: etNotifications,
        superadmin: etSuperadmin,
        shipmentGroup: etShipmentGroup,
        pwa: etPWA,
        entityModal: etEntityModal,
        tasks: etTasks,
        works: etWorks,
        invoicing: etInvoicing,
        orders: etOrders,
        containerOrders: etContainerOrders,
        containerOrderIntake: etContainerOrderIntake,
        devices: etDevices,
      },
    },
    fallbackLng: "en",
    defaultNS: "common",
    ns: [...ns],
    debug: import.meta.env.DEV,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
